<template>
  <Popconfirm
    :placement="placement || 'right'"
    @onConfirm="handleConfirm"
    :cancelText="cancelText"
    :cancelButtonProps="{ class: '!py-2 !bg-primary-light !rounded-xl !tracking-normal !capitalize !text-black !h-auto min-w-[100px]' }"
    :okText="okText"
    :okButtonProps="{ class: '!py-2 !bg-primary-danger !border-none !rounded-xl !tracking-normal !capitalize !text-white !h-auto min-w-[100px]' }"
  >
    <template #title>
      <p class="w-full text-base pb-4 leading-snug text-black text-opacity-90">
        {{ title }}
      </p>
      <p v-if="subTitle" class="w-full leading-snug text-black text-opacity-90">
        {{ subTitle }}
      </p>
    </template>
    <template v-slot:default>
      <slot></slot>
    </template>
  </Popconfirm>
</template>

<script lang="ts">
import { Popconfirm, Button as Abutton } from 'ant-design-vue/lib';
import 'ant-design-vue/lib/popconfirm/style/css';
import 'ant-design-vue/lib/button/style/css';

import { Vue, Options } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Options({
  components: {
    Popconfirm,
    Abutton
  }
})
export default class TlPopConfirm extends Vue {
  @Prop()
  public title!: string;

  @Prop()
  public subTitle!: string;

  @Prop()
  public okText!: string;

  @Prop()
  public cancelText!: string;

  @Prop()
  public placement!: string;

  public handleConfirm() {
    this.$emit('confirm');
  }
}
</script>
